<div class="row" *ngIf="grid">
    <div class="col-12">
        <paginador *ngIf="!buscarPeriodo" [paginas]="paginas" [seleccionada]="seleccionada"
            (cambioPagina)="buscarNuevas($event)"></paginador>
    </div>
</div>
<div class="container-fluid" *ngIf="perfiles.length > 0">
    <div class="col-12" *ngIf="grid" style="text-align: right;">
        <button *ngIf="!ganador" type="button" (click)="ordenarMasVotados()"
            style="color: #2653C6;text-decoration: underline;background-color: none;border: none; background: none;">{{!filtroMasVotados
            ?
            'ver más votados' :
            'ver últimas nominaciones'}}</button>
    </div>
    <div class="row pb-4" *ngIf="!ganador">
        <div class="col-6 colTitulo">
            <h5>{{titulo}}</h5>
        </div>
        <div class="col-6 colVerTodo" *ngIf="!grid && !finalista">
            <a href="#/categoria" type="button">Ver todos</a>
        </div>
    </div>
    <div [ngClass]="grid || ganador ? 'row' : 'infinity'" class="w-100">
        <div [ngClass]="ganador ? 'col-12' : 'col-3 cardPerfil'" *ngFor="let perfil of perfiles">
            <nominacion-card [perfil]="perfil" [finalista]="perfil.finalista && finalista"
                [ganador]="ganador"></nominacion-card>
        </div>
    </div>
</div>
<div class="row" *ngIf="grid">
    <div class="col-12">
        <paginador [paginas]="paginas" [seleccionada]="seleccionada" (cambioPagina)="buscarNuevas($event)"></paginador>
    </div>
</div>